export const allJobCustomViews = [
  {
    "id": 5,
    "name": "Test",
    "type": "Job",
    "columnName": "jobSubmissionData.accountContact,jobSubmissionData.accountName,jobSubmissionData.accountOwner,jobSubmissionData.accountType",
    "createdBy": 1,
    "createdAt": "2024-10-03T16:51:42.683898",
    "updatedBy": 1,
    "updatedAt": "2024-10-03T16:51:42.683898",
    "isDeleted": false,
    "isActive": true,
    "filters": [],
    "externalFilters": null,
    "selected": true
  }
];

export const jobCustomViewMeta = {
  isLoading: false,
}